import { injectable } from "inversify";
import { IAppStore } from "./interfaces";

@injectable()
export class AppStore implements IAppStore {}
